import React, { useState, useCallback } from 'react';
import {
    Button,
    Paper,
    Modal,
    Typography,
    Grid,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { isMobile, isIPad13 } from 'react-device-detect';
import { useSelector, useDispatch } from 'react-redux';
import CesiumViewer from './CesiumViewer';
import { flatlick } from '../../app/three_d_constants';

export default function ThreeDViewer() {
    const dispatch = useDispatch();
    const [cameraView, setCameraView] = useState(null);
    const [open, setOpen] = useState(false);

    const handleCameraChange = useCallback((view) => {
        setCameraView(view);
    }, []);

    const handleClose = () => setOpen(false);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableEnforceFocus
            disableScrollLock
            className={(!isMobile || isIPad13) ? 'full-modal-placement' : 'mobile-modal-placement'}
        >
            <Paper className="three-d" style={{ position: 'relative' }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px',
                    borderBottom: '1px solid #ccc'
                }}
                >
                    <Typography variant="h5" component="div" style={{ textAlign: 'left' }}>
                        <strong>3D Viewer:</strong> Chantilly - Flatlick Valley
                        <Typography variant="subtitle1" style={{ marginTop: 2 }}>
                            c. 1880-1900
                        </Typography>
                    </Typography>

                    <IconButton
                        onClick={handleClose}
                        style={{
                            color: '#1976d2',
                            backgroundColor: 'rgba(25, 118, 210, 0.1)',
                            width: 48,
                            height: 48
                        }}
                        aria-label="close"
                    >
                        <CloseIcon style={{ fontSize: 28 }} />
                    </IconButton>
                </div>
                <Grid container spacing={2} sx={{ px: 2, py: 2 }}>
                    <Grid item xs={6} style={{ height: 'calc(68vh)' }}>
                        <CesiumViewer
                            location={flatlick}
                            onCameraChange={handleCameraChange}
                            externalCameraView={cameraView}
                            setExternalCameraView={setCameraView}
                            id="left"
                        />
                    </Grid>
                    <Grid item xs={6} style={{ height: 'calc(68vh)' }}>
                        <CesiumViewer
                            location={flatlick}
                            onCameraChange={handleCameraChange}
                            externalCameraView={cameraView}
                            setExternalCameraView={setCameraView}
                            id="right"
                            now
                        />
                    </Grid>
                </Grid>
                <Typography variant="subtitle1" style={{ marginTop: 2, marginLeft: '16px' }}>
                    <strong>Visible Landmarks: </strong><Button variant="contained">McAtees Tavern (1789)</Button>&nbsp;<Button variant="contained">Wrenns Store (1867)</Button>&nbsp;<Button variant="contained">Birch House (1860)</Button>&nbsp;<Button variant="contained">Flatlick House (1800)</Button>&nbsp;<Button variant="contained">Birchs Blacksmith Shop (1860)</Button>
                </Typography>
            </Paper>
        </Modal>
    );
}
